"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _epics = require("settings-ui-sdk/SiteSettings/epics");

var _epics2 = require("settings-ui-sdk/DesignTemplates/epics");

var _UpdateSiteSettings = _interopRequireDefault(require("../stagedObjects/UpdateSiteSettings"));

var _saveDefaultProperties = _interopRequireDefault(require("./saveDefaultProperties"));

var _default = (0, _reduxObservable.combineEpics)(_epics.fetchSiteSettings, _epics.updateSiteSettings, _epics.updateSiteSettingsMergeTags, _epics2.fetchStylesheets, _epics2.fetchSystemTemplates, _UpdateSiteSettings.default.getResetChangesToStagedObjectEpic(), _saveDefaultProperties.default);

exports.default = _default;
module.exports = exports.default;